
import { Record } from "../../fable_modules/fable-library-js.5.0.0/Types.js";
import { record_type, float64_type, option_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import { TextModule_View } from "../../Components/StenaWebUI/Core/Text.js";
import { tryFind, ofList } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { toArray as toArray_1, cons, ofArray, append, tryPick, head, truncate, length, forAll, sortBy, mapIndexed, collect, exists, filter, singleton, map } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { DateTimeOffset_adjustFromContext, DateTimeOffset_dateTimeStr, DateTimeOffset_DateTimeWithTimezone } from "../../Components/TimeZones/Components.js";
import { createObj, int32ToString, int64ToString, compare, safeHash, equals, stringHash, round, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { printf, toText } from "../../fable_modules/fable-library-js.5.0.0/String.js";
import { map as map_1, defaultArg, flatten } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { List_groupBy, List_distinct, List_distinctBy } from "../../fable_modules/fable-library-js.5.0.0/Seq2.js";
import { toUniversalTime, getUtcTicks } from "../../fable_modules/fable-library-js.5.0.0/DateOffset.js";
import { compare as compare_1 } from "../../fable_modules/fable-library-js.5.0.0/Date.js";
import { ViewHelpers_divWith } from "./PortWindCommon.js";
import { StandardTableModule_view } from "../../Components/StenaWebUI/Grid/StandardTable.js";
import { empty, singleton as singleton_1, append as append_1, delay, toArray, toList } from "../../fable_modules/fable-library-js.5.0.0/Seq.js";

export class TableRow extends Record {
    constructor(Id, DateTime, DateTimeStart, Values) {
        super();
        this.Id = Id;
        this.DateTime = DateTime;
        this.DateTimeStart = DateTimeStart;
        this.Values = Values;
    }
}

export function TableRow_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Table.TableRow", [], TableRow, () => [["Id", string_type], ["DateTime", class_type("System.DateTimeOffset")], ["DateTimeStart", option_type(class_type("System.DateTimeOffset"))], ["Values", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, option_type(float64_type)])]]);
}

function TableHelpers_renderTimeCell($props) {
    const p = $props.p;
    return TextModule_View(ofList(map((value) => value, singleton(["children", singleton(createElement(DateTimeOffset_DateTimeWithTimezone, {
        dateTime: p.value,
    }))])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
}

function TableHelpers_renderValueCell($props) {
    let arg;
    const p = $props.p;
    const matchValue = p.value;
    if (matchValue != null) {
        return TextModule_View(ofList(map((value_3) => value_3, singleton(["children", (arg = round(matchValue, 3), toText(printf("%A"))(arg))])), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        }));
    }
    else {
        return TextModule_View(ofList(map((value_1) => value_1, singleton(["children", "-"])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }));
    }
}

function getValue(d, r) {
    return flatten(tryFind(d.ChartName, r.Values));
}

function buildTableData(multipleChartsValues, state) {
    const data = state.WeatherHistory;
    let defs;
    const flat = filter((d_1) => exists((w) => (d_1.GetValue(state, w) != null), data), List_distinctBy((d) => d.ChartName, collect((x) => x, multipleChartsValues), {
        Equals: (x_1, y) => (x_1 === y),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    }));
    const paramOrder = ofList(mapIndexed((i, id) => [id, i], List_distinct(map((d_2) => d_2.Id, flat), {
        Equals: equals,
        GetHashCode: (x_2) => (safeHash(x_2) | 0),
    })), {
        Compare: (x_3, y_2) => (compare(x_3, y_2) | 0),
    });
    defs = sortBy((d_3) => (defaultArg(tryFind(d_3.Id, paramOrder), 0) | 0), flat, {
        Compare: (x_4, y_3) => (comparePrimitives(x_4, y_3) | 0),
    });
    return [defs, sortBy((_arg_4) => _arg_4.DateTime, collect((tupledArg) => {
        let group_1, dt;
        const group_2 = tupledArg[1];
        if (forAll((d_4) => (length(truncate(2, filter((r) => (getValue(d_4, r) != null), group_2))) <= 1), defs)) {
            return singleton((group_1 = group_2, (dt = head(group_1).DateTime, new TableRow(int64ToString(getUtcTicks(toUniversalTime(dt))), dt, tryPick((_arg_1) => _arg_1.DateTimeStart, group_1), ofList(map((d_5) => [d_5.ChartName, tryPick((r_1) => getValue(d_5, r_1), group_1)], defs), {
                Compare: (x_5, y_4) => (comparePrimitives(x_5, y_4) | 0),
            })))));
        }
        else {
            return mapIndexed((i_1, r_2) => (new TableRow((r_2.Id + "-") + int32ToString(i_1), r_2.DateTime, r_2.DateTimeStart, r_2.Values)), group_2);
        }
    }, List_groupBy((arg) => DateTimeOffset_dateTimeStr(arg.DateTime), map((w_1) => (new TableRow(int64ToString(getUtcTicks(toUniversalTime(w_1.DateTime))), w_1.DateTime, w_1.DateTimeMeanStart, ofList(map((d_6) => [d_6.ChartName, d_6.GetValue(state, w_1)], defs), {
        Compare: (x_6, y_5) => (comparePrimitives(x_6, y_5) | 0),
    }))), data), {
        Equals: (x_7, y_6) => (x_7 === y_6),
        GetHashCode: (x_7) => (stringHash(x_7) | 0),
    })), {
        Compare: (x_8, y_7) => (compare_1(x_8, y_7) | 0),
    }), exists((w_2) => (w_2.DateTimeMeanStart != null), data)];
}

export function buildCsvContent(multipleChartsValues, ctx, state) {
    const patternInput = buildTableData(multipleChartsValues, state);
    const isMeanValues = patternInput[2];
    const defs = patternInput[0];
    const formatTime = (dt) => DateTimeOffset_dateTimeStr(DateTimeOffset_adjustFromContext(ctx, dt));
    return [isMeanValues, cons(append(isMeanValues ? ofArray(["Start", "End"]) : singleton("Time"), map((_arg) => _arg.ChartName, defs)), map((row) => append(isMeanValues ? ofArray([defaultArg(map_1(formatTime, row.DateTimeStart), ""), formatTime(row.DateTime)]) : singleton(formatTime(row.DateTime)), map((d_1) => {
        const v = getValue(d_1, row);
        if (v != null) {
            const v_1 = v;
            return round(v_1, 3).toString();
        }
        else {
            return "";
        }
    }, defs)), patternInput[1]))];
}

export function PortWindTableView($props) {
    const state = $props.state;
    const multipleChartsValues = $props.multipleChartsValues;
    const patternInput = buildTableData(multipleChartsValues, state);
    const rows = patternInput[1];
    const isMeanValues = patternInput[2];
    const defs = patternInput[0];
    return ViewHelpers_divWith([["style", {
        overflowX: "scroll",
        overflowY: "scroll",
        height: 80 + "vh",
    }]], singleton(StandardTableModule_view(createObj(toList([["variant", "compact"], ["items", toArray(rows)], ["loading", length(rows) === 0], ["config", createObj(toList([["keyResolver", (i) => i.Id], ["disableSorting", true], ["stickyHeader", true], ["columns", createObj(toArray_1(append(toList(delay(() => {
        let columnProps;
        return append_1(isMeanValues ? singleton_1((columnProps = createObj(toList([["name", "timeStart"], ["itemValueResolver", (_arg) => _arg.DateTimeStart], ["columnLabel", "Start"], ["infoIconTooltipText", "Mean window start time - values are mean of data in window"], ["width", toText(`${240}px`)], ["renderCell", (p) => createElement(TableHelpers_renderTimeCell, {
            p: p,
        })]])), [columnProps.name, columnProps])) : empty(), delay(() => {
            let columnProps_1;
            return singleton_1((columnProps_1 = createObj(toList(toList(delay(() => append_1(singleton_1(["name", "time"]), delay(() => append_1(singleton_1(["itemValueResolver", (_arg_1) => _arg_1.DateTime]), delay(() => append_1(isMeanValues ? append_1(singleton_1(["columnLabel", "End"]), delay(() => singleton_1(["infoIconTooltipText", "Mean window end time - values are mean of data in window"]))) : singleton_1(["columnLabel", "Time"]), delay(() => append_1(singleton_1(["width", toText(`${240}px`)]), delay(() => singleton_1(["renderCell", (p_1) => createElement(TableHelpers_renderTimeCell, {
                p: p_1,
            })]))))))))))))), [columnProps_1.name, columnProps_1]));
        }));
    })), map((d) => {
        const columnProps_2 = createObj(toList([["name", d.ChartName], ["itemValueResolver", (r) => getValue(d, r)], ["columnLabel", d.ChartName], ["width", toText(`${140}px`)], ["renderCell", (p_2) => createElement(TableHelpers_renderValueCell, {
            p: p_2,
        })]]));
        return [columnProps_2.name, columnProps_2];
    }, defs))))], ["columnOrder", toArray_1(append(isMeanValues ? ofArray(["timeStart", "time"]) : singleton("time"), map((_arg_2) => _arg_2.ChartName, defs)))]]))]])))));
}

